import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { Union } from '../models/union';
import { UnionService } from './union.service';
import { ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class UnionDomain {

    $subscriptions: Subscription[] = [];
    unionData: Union = new Union;
    qrCodeInitialString: string = `https://${window.location.host}/#/users-status?qr_code=`

    constructor(
        private unionService: UnionService,
        private toastr: ToastrService,
    ) {
        this.getUnion();
    }

    async ngOnInit(): Promise<void> {
        await this.getUnion();
    }

    ngOnDestroy(): void {
        this.$subscriptions.forEach(s => s.unsubscribe());
    }

    getUnion = async (): Promise<void> => {
        this.$subscriptions.push(this.unionService.getSingleUnion().subscribe({
            next: (res) => {
                this.unionData = res;
            },
            error: (err) => {
                this.toastr.error(err.message);
            }
        }));
    };

    vataNumberToVataName = (vataNumber: number): string => {
        let vataName: string = '';
        switch (vataNumber) {
            case 1:
                vataName = 'প্রতিবন্ধী ভাতা'
                break;
            case 2:
                vataName = 'বয়স্ক ভাতা'
                break;
            case 3:
                vataName = 'বিধবা ভাতা'
                break;
            case 4:
                vataName = 'মুক্তি যোদ্ধা'
                break;
            case 5:
                vataName = 'অন্যান্য'
                break;
            case 6:
                vataName = 'কোনটিই না'
                break;
            default:
                break;
        }
        return vataName;
    }

    peshaNumberToPeshaName = (peshaNumber: number): string => {
        let peshaName: string = '';
        switch (peshaNumber) {
            case 1:
                peshaName = 'কৃষি'
                break;
            case 2:
                peshaName = 'ব্যবসা'
                break;
            case 3:
                peshaName = 'বেসরকারি চাকরি'
                break;
            case 4:
                peshaName = 'সরকারি চাকরি'
                break;
            case 5:
                peshaName = 'প্রবাসী'
                break;
            case 6:
                peshaName = 'গৃহিণী'
                break;
            case 7:
                peshaName = 'দিন মজুর'
                break;
            case 8:
                peshaName = 'অবসর'
                break;
            case 9:
                peshaName = 'ড্রাইভার'
                break;
            case 10:
                peshaName = 'অন্যান্য'
                break;
        }
        return peshaName;
    }

    khanarDhoronNumberToKhanarDhoronName = (khanarDhoronNumber: number): string => {
        let khanarDhoronName: string = '';
        switch (khanarDhoronNumber) {
            case 1:
                khanarDhoronName = 'এক চালা'
                break;
            case 2:
                khanarDhoronName = 'দুই চালা'
                break;
            case 3:
                khanarDhoronName = 'চার চালা'
                break;
            case 4:
                khanarDhoronName = 'আধা পাকা'
                break;
            case 5:
                khanarDhoronName = 'পাকা'
                break;
            case 6:
                khanarDhoronName = 'এক তলা'
                break;
            case 7:
                khanarDhoronName = 'দোতলা'
                break;
            case 8:
                khanarDhoronName = 'তিনতলা'
                break;
            case 9:
                khanarDhoronName = 'চারতলা'
                break;
            case 10:
                khanarDhoronName = 'বহুতল'
                break;
        }
        return khanarDhoronName;
    }

    khanarDhoronNumberToKhanarMulloAndTax = (khanarDhoronNumber: number): { khanarMullo: number, khanarTax: number } => {
        let khana: { khanarMullo: number, khanarTax: number } = { khanarMullo: 0.0, khanarTax: 0.0 };
        switch (khanarDhoronNumber) {
            case 1:
                khana = { khanarMullo: this.unionData.ek_chala, khanarTax: this.unionData.ek_chala_kor }
                break;
            case 2:
                khana = { khanarMullo: this.unionData.dui_chala, khanarTax: this.unionData.dui_chala_kor }
                break;
            case 3:
                khana = { khanarMullo: this.unionData.char_chala, khanarTax: this.unionData.char_chala_kor }
                break;
            case 4:
                khana = { khanarMullo: this.unionData.adha_paka, khanarTax: this.unionData.adha_paka_kor }
                break;
            case 5:
                khana = { khanarMullo: this.unionData.paka, khanarTax: this.unionData.paka_kor }
                break;
            case 6:
                khana = { khanarMullo: this.unionData.ek_tola, khanarTax: this.unionData.ek_tola_kor }
                break;
            case 7:
                khana = { khanarMullo: this.unionData.dui_tola, khanarTax: this.unionData.dui_tola_kor }
                break;
            case 8:
                khana = { khanarMullo: this.unionData.tin_tola, khanarTax: this.unionData.tin_tola_kor }
                break;
            case 9:
                khana = { khanarMullo: this.unionData.char_tola, khanarTax: this.unionData.char_tola_kor }
                break;
            case 10:
                khana = { khanarMullo: this.unionData.bohutol, khanarTax: this.unionData.bohutol_kor }
                break;
        }
        return khana;
    }

    convertEnglishHoldingNumberToBanglaHoldingNumber = (holding_number: string): string => {
        holding_number = holding_number.replaceAll('1','১')
        holding_number = holding_number.replaceAll('2','২')
        holding_number = holding_number.replaceAll('3','৩')
        holding_number = holding_number.replaceAll('4','৪')
        holding_number = holding_number.replaceAll('5','৫')
        holding_number = holding_number.replaceAll('6','৬')
        holding_number = holding_number.replaceAll('7','৭')
        holding_number = holding_number.replaceAll('8','৮')
        holding_number = holding_number.replaceAll('9','৯')
        holding_number = holding_number.replaceAll('0','০')
        return holding_number;
    }

    getEquivalentSortingNumber = (holding_number: string): number => {
        let b = holding_number.split('/');
        if (b.length > 1) {
            b[1] = b[1].replaceAll('১', '1')
            b[1] = b[1].replaceAll('২', '2')
            b[1] = b[1].replaceAll('৩', '3')
            b[1] = b[1].replaceAll('৪', '4')
            b[1] = b[1].replaceAll('৫', '5')
            b[1] = b[1].replaceAll('৬', '6')
            b[1] = b[1].replaceAll('৭', '7')
            b[1] = b[1].replaceAll('৮', '8')
            b[1] = b[1].replaceAll('৯', '9')
            b[1] = b[1].replaceAll('০', '0')
        }
        b[0] = b[0].replaceAll('১', '1')
        b[0] = b[0].replaceAll('২', '2')
        b[0] = b[0].replaceAll('৩', '3')
        b[0] = b[0].replaceAll('৪', '4')
        b[0] = b[0].replaceAll('৫', '5')
        b[0] = b[0].replaceAll('৬', '6')
        b[0] = b[0].replaceAll('৭', '7')
        b[0] = b[0].replaceAll('৮', '8')
        b[0] = b[0].replaceAll('৯', '9')
        b[0] = b[0].replaceAll('০', '0')

        let equvalentNumber: number = 0;
        if (b.length > 1) {
            equvalentNumber = Number(b[0]) + (Number(b[1]) / 1000000);
        } else {
            equvalentNumber = Number(b[0]);
        }
        return equvalentNumber;
    }
}
